<template>
    <div class="magicCube" :style="'height:' + positionHeight * sideLength + 'px; margin-top:' + item.mbConfig.val +'px; margin-left:' + item.lrEdge.val +'px;'">
        <div class="customizeBox" v-for="(boxItem,index) in item.magicCube.boxList" :key="index"
             :style="'width:' + boxItem.widthNumber * sideLength + 'px; height:' + boxItem.heightNumber * sideLength + 'px; top:' + boxItem.top * sideLength + 'px; left:' + boxItem.left * sideLength + 'px; padding:' + item.padding.val + 'px'">
            <img :class="{'border-radius': item.bgStyle.type === 1}" v-if="boxItem.imageUrl" :src="boxItem.imageUrl">
            <img v-else src="@/components/decoration/static/not_img_product.png">
        </div>
        <div class="notCustomizeBox" :style="'width: ' + sideLength * item.magicCube.modeNumber + 'px; height: ' + sideLength * item.magicCube.modeNumber + 'px;'" v-if="item.magicCube.boxList.length === 0">
            <img src="@/components/decoration/static/cube_default.png">
        </div>
    </div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            default:{}
        }
    },
    data() {
        return{
        }
    },
    computed:{
        // 动态配置数组
        modeData(){
            return [
                { modeType: 4, modeText: "4x4", sideLength: (350 - this.item.lrEdge.val * 2) / 4 },
                { modeType: 5, modeText: "5x5", sideLength: (350 - this.item.lrEdge.val * 2) / 5 },
                { modeType: 6, modeText: "6x6", sideLength: (350 - this.item.lrEdge.val * 2) / 6 },
                { modeType: 7, modeText: "7x7", sideLength: (350 - this.item.lrEdge.val * 2) / 7 }
            ]
        },

        // 边长
        sideLength(){
            console.log("modeNumber>" + this.item.magicCube.modeNumber)
            return  this.modeData.find(item=>item.modeType === this.item.magicCube.modeNumber).sideLength
        },

        // 定位高度计算
        positionHeight(){
            let maxX = 0;
            if(this.item.magicCube.boxList.length === 0){
                return this.item.magicCube.modeNumber;
            }
            this.item.magicCube.boxList.forEach(item=>{
                if(maxX < item.end.split(",")[1]){
                    maxX = item.end.split(",")[1];
                }
            })

            console.log("modeNumber", this.item.magicCube.modeNumber)
            console.log("sideLength", this.sideLength)
            return maxX;
        }
    },

}
</script>

<style scoped lang="scss">
.magicCube{
    position: relative;
    width: 100%;

    .customizeBox{
        position: absolute;

        img{
            width: 100%;
            height: 100%;
        }
    }
}

.border-radius{
    border-radius: 6px;
    overflow: hidden;
}
</style>